export default __webpack_public_path__ + "static/media/330_portfolio02-jp-mobile.5a53f903.png";